import { Component, EventEmitter, Output } from '@angular/core';
import { AppService } from '../../services/app.service';

/**
 * Navegacion inferior para mobile. En desktop no se muestra: ahi manda la
 * sidebar.
 *
 * El prototipo mobile explica el criterio de reparto: "La tab bar admite cinco
 * entradas y el brief pide siete secciones. Las tres menos frecuentes van acá,
 * en un sheet, en vez de apretar la barra."
 */
@Component({
  selector: 'app-tabbar',
  templateUrl: './tabbar.component.html',
  styleUrls: ['./tabbar.component.scss']
})
export class TabbarComponent {

  @Output() cerrarSesion = new EventEmitter<void>();

  sheetAbierto = false;

  // Las cuatro secciones frecuentes van en la barra; el resto en el sheet.
  // "Compras" se reemplazo por "Puntos" (historial); "Que queres recibir" se
  // oculta del menu (la pantalla /preferencias sigue existiendo).
  tabs = [
    { texto: 'Resumen',    ruta: '/home' },
    { texto: 'Mascotas',   ruta: '/mis-mascotas' },
    { texto: 'Puntos',     ruta: '/historial-puntos' },
    { texto: 'Beneficios', ruta: '/mis-beneficios' }
  ];

  enSheet = [
    { texto: 'Mis datos',           ruta: '/edit-customer' },
    { texto: 'Mis domicilios',      ruta: '/customer-adress-list' }
  ];

  constructor(public appService : AppService) {}

  get urlPuppisClub() : string {
    const co = this.appService.countryCode === 'CO';
    return co ? 'https://www.puppis.com.co/puppis-club' : 'https://www.puppis.com.ar/puppis-club';
  }

  abrirSheet() { this.sheetAbierto = true; }

  cerrarSheet() { this.sheetAbierto = false; }
}
